export default __webpack_public_path__ + "static/media/37.d996e351.jpeg";